const MinimalTemplate = ({ candidateData }) => {
    if (!candidateData) return null

    const {
        name,
        email,
        phone,
        basic_details,
        employment,
        education,
        projects,
        certifications,
        it_skills,
        candidate_languages,
    } = candidateData

    return (
        <div className="w-[210mm] min-h-[297mm] max-w-[210mm] mx-auto bg-white text-gray-900 font-sans leading-relaxed box-border relative overflow-hidden p-8">
            {/* Header */}
            <div className="border-b-2 border-gray-200 pb-6 mb-8">
                <h1 className="text-4xl font-light text-gray-800 mb-2">{name}</h1>
                <p className="text-lg text-gray-600 mb-4 text-center">{employment?.[0]?.job_title?.title || "Professional"}</p>
                <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-600">
                    <div className="flex items-center">
                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                            />
                        </svg>
                        {email}
                    </div>
                    <div className="flex items-center">
                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                            />
                        </svg>
                        {phone}
                    </div>
                    <div className="flex items-center">
                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                            />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        {basic_details?.city?.name}, {basic_details?.state?.name}
                    </div>
                </div>
            </div>

            {/* Summary */}
            {basic_details?.profile_summery && (
                <div className="mb-8">
                    <h2 className="text-lg font-medium text-gray-800 mb-3 uppercase tracking-wide">Professional Summary</h2>
                    <p className="text-sm leading-relaxed text-gray-700">{basic_details.profile_summery}</p>
                </div>
            )}

            {/* Experience */}
            {employment && employment.length > 0 && (
                <div className="mb-8">
                    <h2 className="text-lg font-medium text-gray-800 mb-4 uppercase tracking-wide">Experience</h2>
                    <div className="space-y-6">
                        {employment.map((job, index) => (
                            <div key={index}>
                                <div className="flex justify-between items-start mb-2">
                                    <div>
                                        <h3 className="text-base font-medium text-gray-800">{job.job_title?.title}</h3>
                                        <p className="text-sm text-gray-600">{job.current_company}</p>
                                    </div>
                                    <span className="text-sm text-gray-500 whitespace-nowrap ml-4">
                                        {job.start_month}/{job.start_year} -{" "}
                                        {job.end_month ? `${job.end_month}/${job.end_year}` : "Present"}
                                    </span>
                                </div>
                                <p className="text-sm text-gray-700 leading-relaxed">{job.job_profile}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Education */}
            {education && education.length > 0 && (
                <div className="mb-8">
                    <h2 className="text-lg font-medium text-gray-800 mb-4 uppercase tracking-wide">Education</h2>
                    <div className="space-y-4">
                        {education.map((edu, index) => (
                            <div key={index}>
                                <div className="flex justify-between items-start mb-1">
                                    <div>
                                        <h3 className="text-base font-medium text-gray-800">{edu.education_course?.title}</h3>
                                        <p className="text-sm text-gray-600">{edu.insitute_university}</p>
                                    </div>
                                    <span className="text-sm text-gray-500 whitespace-nowrap ml-4">
                                        {edu.course_duration_start_year} - {edu.course_duration_end_year}
                                    </span>
                                </div>
                                {edu.education_course_specialty && (
                                    <p className="text-sm text-gray-600">
                                        {edu.education_course_specialty.title} • {edu.marks}%
                                    </p>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Skills */}
            {it_skills && it_skills.length > 0 && (
                <div className="mb-8">
                    <h2 className="text-lg font-medium text-gray-800 mb-4 uppercase tracking-wide">Technical Skills</h2>
                    <div className="grid grid-cols-2 gap-4">
                        {it_skills.map((skill, index) => (
                            <div key={index} className="flex justify-between items-center">
                                <span className="text-sm text-gray-700">{skill.skill.title}</span>
                                <span className="text-xs text-gray-500">
                                    {skill.experience_year}y {skill.experience_month}m
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Projects */}
            {projects && projects.length > 0 && (
                <div className="mb-8">
                    <h2 className="text-lg font-medium text-gray-800 mb-4 uppercase tracking-wide">Projects</h2>
                    <div className="space-y-4">
                        {projects.map((project, index) => (
                            <div key={index}>
                                <div className="flex justify-between items-start mb-2">
                                    <h3 className="text-base font-medium text-gray-800">{project.project_tag}</h3>
                                    <span
                                        className={`text-xs px-2 py-1 rounded ${project.project_status === "Ongoing" ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-700"
                                            }`}
                                    >
                                        {project.project_status}
                                    </span>
                                </div>
                                <p className="text-sm text-gray-700 leading-relaxed mb-2">{project.project_description}</p>
                                <p className="text-xs text-gray-500">
                                    Role: {project.role} • Team Size: {project.team_size}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Certifications & Languages */}
            <div className="grid grid-cols-2 gap-8">
                {/* Certifications */}
                {certifications && certifications.length > 0 && (
                    <div>
                        <h2 className="text-lg font-medium text-gray-800 mb-4 uppercase tracking-wide">Certifications</h2>
                        <div className="space-y-2">
                            {certifications.map((cert, index) => (
                                <div key={index}>
                                    <p className="text-sm font-medium text-gray-700">{cert.certification_name}</p>
                                    {cert.certification_date && <p className="text-xs text-gray-500">{cert.certification_date}</p>}
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Languages */}
                {candidate_languages && candidate_languages.length > 0 && (
                    <div>
                        <h2 className="text-lg font-medium text-gray-800 mb-4 uppercase tracking-wide">Languages</h2>
                        <div className="space-y-2">
                            {candidate_languages.map((lang, index) => (
                                <div key={index} className="flex justify-between">
                                    <span className="text-sm text-gray-700">{lang.language}</span>
                                    <span className="text-xs text-gray-500">{getLanguageProficiency(lang)}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

// Helper function to format language proficiency
const getLanguageProficiency = (lang) => {
    const abilities = []
    if (lang.can_read) abilities.push("Read")
    if (lang.can_write) abilities.push("Write")
    if (lang.can_speak) abilities.push("Speak")

    if (abilities.length === 3) return "Fluent"
    if (abilities.length === 2) return "Intermediate"
    if (abilities.length === 1) return "Basic"
    return "None"
}

export default MinimalTemplate
